// extracted by mini-css-extract-plugin
export default {"placeholder":"TextInput1_placeholder__xG2TT","textInput":"TextInput1_textInput__xAyup"};